import React, { useState } from 'react';

import { useAppDispatch } from 'segments/hooks';

import { changeActiveCoach, CoachInfo, useGetCoachesListQuery } from 'features/coaches';
import { changeActiveModal } from 'features/modals';

import { CoachesTable } from './components/CoachesTable';

const defaultPageSize = 30;

const initParams = {
  page: 1,
  pageSize: defaultPageSize,
};

export const CoachesTablePage = () => {
  const [params, setParams] = useState(initParams);
  const dispatch = useAppDispatch();

  const {
    coachesList,
    coachesCount,
    isCoachesFetching,
  } = useGetCoachesListQuery(undefined, {
    selectFromResult: ({ data, isFetching }) => ({
      coachesList: data ?? [],
      coachesCount: data?.length ?? 0,
      isCoachesFetching: isFetching,
    })
  });

  const handlePaginationChange = (page: number, pageSize: number) => {
    setParams((prev) => ({
      ...prev,
      page,
      pageSize,
    }));
  };

  const handleEditClick = (coach: CoachInfo) => {
    dispatch(changeActiveModal('edit-coach-modal'));
    dispatch(changeActiveCoach(coach));
  };

  const handleCreateClick = () => {
    dispatch(changeActiveModal('create-coach-modal'));
  };

  return (
    <div>
      <CoachesTable
        items={coachesList}
        itemsTotal={coachesCount}
        currentPage={params.page}
        defaultPageSize={defaultPageSize}
        onPageChange={handlePaginationChange}
        isLoading={isCoachesFetching}
        onEditClick={handleEditClick}
        onCreateClick={handleCreateClick}
      />
    </div>
  );
};

